import './App.css';
import Home from './views/Home';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {createBrowserRouter, RouterProvider,} from 'react-router-dom';
import {URLS} from './constants/appConstants';
import OtherApps from './views/OtherApps';
import Profile from './views/Profile';
import Activities from './views/Activities';
import ErrorPage from './components/error-page';
import Root from './routes/root';
import CategoryPage from './views/CategoryPage';
import Categories from './views/Categories';
import OtherUsersProfile from './views/OtherUsersProfile';
import ImageFullScreen from './views/ImageFullScreen';
import Hashtag from './views/Hashtag';
import FilteredPolls from './views/FilteredPolls';
import CreatePolls from './views/CreatePolls';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import PollSingle from './views/PollSingle';
import SearchResults from './views/SearchResults';
import EditProfile from './views/EditProfile';
import NotificationSettings from './views/NotificationSettings';
import LanguageSelection from './views/LanguageSelection';
import SignInPage from './views/SignInPage';
import PrivacyPolicy from './views/PrivacyPolicy';
import ContentLanguageSelection from './views/ContentLanguageSelection';
import LeaderboardView from './views/LeaderboardView';
import LogoMaker from './views/LogoMaker';
import FirebasePage from './views/FirebasePage';
import BuyCoins from './views/BuyCoins';
import CoinsDashboard from './views/CoinsDashboard';
import SupabaseTestPage from './views/SupabaseTestPage';
import CloudFunctionTestPage from './views/CloudFunctionTestPage';
import SelectQuestionType from './views/SelectQuestionType';
import {QuestionExamples} from './views/questionTypeExamples/QuestionExamples';
import JigsawPuzzle from './views/questionTypeExamples/JigsawPuzzleExample';
import CrosswordPuzzle from './views/questionTypeExamples/CrosswordPuzzle';
import FlashcardExample from './views/questionTypeExamples/FlashcardExample';
import DoublePuzzle from './views/questionTypeExamples/DoublePuzzle';
import JigsawPuzzleTask from './views/JigsawPuzzleTask';
import DeleteAccount from './views/DeleteAccount';
import ChildSafetypolicy from './views/ChildSafetyPolicy';

const router = createBrowserRouter([
  {
    path: URLS.SIGN_IN,
    element: <SignInPage/>,
  },
  {
    path: '/',
    element: <Root/>,
    errorElement: <ErrorPage/>,
    children: [
      {
        path: URLS.HOME,
        element: <Home/>,
      },
      {
        path: URLS.PRIVACY_POLICY,
        element: <PrivacyPolicy/>,
      },
      {
        path: URLS.CHILD_POLICY,
        element: <ChildSafetypolicy/>,
      },
      {
        path: URLS.DELETE_ACCOUNT,
        element: <DeleteAccount/>,
      },
      {
        path: URLS.SETTINGS,
        element: <Profile/>,
      },
      {
        path: URLS.ACTIVITIES,
        element: <Activities/>,
      },
      {
        path: URLS.OTHER_APPS,
        element: <OtherApps/>,
      },
      {
        path: URLS.CATEGORY_ONE,
        element: <CategoryPage/>,
      },
      {
        path: URLS.CATEGORY,
        element: <Categories/>,
      },
      {
        path: URLS.PROFILE,
        element: <OtherUsersProfile/>,
      },
      {
        path: URLS.IMAGE_FULL_SCREEN,
        element: <ImageFullScreen/>,
      },
      {
        path: URLS.HASHTAG,
        element: <Hashtag/>,
      },
      {
        path: URLS.FILTERS,
        element: <FilteredPolls/>,
      },
      {
        path: URLS.QUESTION_CREATE,
        element: <CreatePolls/>,
      },
      {
        path: URLS.QUESTION_SINGLE,
        element: <PollSingle/>,
      },
      {
        path: URLS.SEARCH,
        element: <SearchResults/>,
      },
      {
        path: URLS.PROFILE_EDIT,
        element: <EditProfile/>,
      },
      {
        path: URLS.PROFILE_NOTIFICATION_SETTINGS,
        element: <NotificationSettings/>,
      },
      {
        path: URLS.LANGUAGE_SELECTION,
        element: <LanguageSelection/>,
      },
      {
        path: URLS.CONTENT_LANGUAGE_SELECTION,
        element: <ContentLanguageSelection/>,
      },
      {
        path: URLS.LEADERBOARD,
        element: <LeaderboardView/>,
      },
      {
        path: URLS.LOGO,
        element: <LogoMaker/>,
      },
      {
        path: URLS.FIREBASE,
        element: <FirebasePage/>,
      },
      {
        path: URLS.BUY_COINS,
        element: <BuyCoins/>,
      },
      {
        path: URLS.COINS_DASHBOARD,
        element: <CoinsDashboard/>,
      },
      {
        path: URLS.SUPABASE,
        element: <SupabaseTestPage/>,
      },
      {
        path: URLS.CLOUD_FUNCTION_TEST,
        element: <CloudFunctionTestPage/>,
      },
      {
        path: URLS.SELECT_QUESTION_TYPE,
        element: <SelectQuestionType/>,
      },
      {
        path: URLS.QUESTION_EXAMPLES,
        element: <QuestionExamples/>,
      },
      {
        path: URLS.QUESTION_EXAMPLE_JIGSAW_PUZZLE,
        element: <JigsawPuzzle/>,
      },
      {
        path: URLS.QUESTION_EXAMPLE_CROSSWORD,
        element: <CrosswordPuzzle/>,
      },
      {
        path: URLS.QUESTION_EXAMPLE_FLASH_CARD,
        element: <FlashcardExample/>,
      },
      {
        path: URLS.QUESTION_EXAMPLE_DOUBLE_PUZZLE,
        element: <DoublePuzzle word={'example'}/>,
      },
      {
        path: URLS.JIGSAW_PUZZLE_TASK,
        element: <JigsawPuzzleTask/>,
      },
    ]
  },
]);

function App() {

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <RouterProvider router={router}/>
      </LocalizationProvider>
    </>
  );
}

export default App;
